export const getters = {
  pagingLimit: state => state.pagingLimit || localStorage.getItem('employeeboard_paginglimit') ? parseInt(localStorage.getItem('employeeboard_paginglimit')) : 10
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/employeeboard/getters.js